module.exports = __webpack_public_path__ + "img/banner-login.1ce89293.svg";